












































































import Vue from 'vue';
import Modal from '../common/Modal/Modal.vue';
import Button from '../common/Button/Button.vue';
import TextArea from '../common/TextArea/TextArea.vue';
import Input from '../common/Input/Input.vue';
import LabelQualityGoalList from './LabelQualityGoalList.vue';

import { numToKor } from '../../utils/parsers';
import {
  LabelQualityGoal,
  QualityGoalType,
} from '../../interfaces/types/QualityGoal';
import { createQualityGoal } from '@/utils/axiosInstances';
import { isUnique } from '@/utils/array';
import { showUnsupportedMessage } from '@/utils/demoUtils';

export default Vue.extend({
  components: {
    Modal,
    Button,
    TextArea,
    Input,
    LabelQualityGoalList,
  },
  data(): {
    labelGoalList: LabelQualityGoal[];
    isLabelGoalPostable: boolean;
    qualityGoalName: string;
    qualityGoalDescription: string;
    qualityGoalQuantityGoal: string;
    qualityGoalSchemaErrorRate: string;
  } {
    return {
      labelGoalList: [],
      isLabelGoalPostable: false,
      qualityGoalName: '',
      qualityGoalDescription: '',
      qualityGoalQuantityGoal: '0',
      qualityGoalSchemaErrorRate: '0',
    };
  },
  mounted() {
    this.$store.commit('stopLoading');
  },
  computed: {
    isCountInvalid: function (): boolean {
      if (!this.qualityGoalQuantityGoal) {
        return true;
      }
      const parsed = parseInt(this.qualityGoalQuantityGoal);
      return isNaN(parsed) || parsed > 1000000000000000;
    },
    isPercentInvalid: function (): boolean {
      if (!this.qualityGoalSchemaErrorRate) {
        return true;
      }
      const parsed = parseFloat(this.qualityGoalSchemaErrorRate);
      return isNaN(parsed) || parsed > 100 || parsed < 0;
    },
    isNameDuplicated: function (): boolean {
      return (
        this.labelGoalList.some((i) => i === undefined) ||
        !isUnique(this.labelGoalList.map((i) => i.labelName))
      );
    },
    quantityGoalNaturalLanguage: function (): string {
      if (!this.isCountInvalid)
        return numToKor(parseInt(this.qualityGoalQuantityGoal));
      else return '';
    },
    isPostable: function (): boolean {
      let postable =
        !!this.qualityGoalName &&
        !this.isCountInvalid &&
        !this.isPercentInvalid &&
        !this.isNameDuplicated;
      if (this.labelGoalList.length > 0) {
        postable = postable && this.isLabelGoalPostable;
      }
      return postable;
    },
  },
  methods: {
    addLabelGoal() {
      this.labelGoalList.push({
        labelName: '',
        type: '',
        description: '',
        method: '',
      });
    },
    async confirmInput() {
      showUnsupportedMessage(this.$toast);
      this.$emit('closeModal');

      // const compoundedQualityGoal: QualityGoalType = {
      //   name: this.qualityGoalName,
      //   description: this.qualityGoalDescription,
      //   qualityGoal: {
      //     metaQualityGoal: {
      //       schemaErrorRate: parseFloat(this.qualityGoalSchemaErrorRate),
      //       quantityGoal: parseInt(this.qualityGoalQuantityGoal),
      //     },
      //     labelQualityGoal: {},
      //   },
      // };

      // let confirmText =
      //   `다음 정보가 맞습니까?\n\n` +
      //   `목표 구문 정확도: ${this.qualityGoalSchemaErrorRate}%\n` +
      //   `목표 데이터 수량: ${this.qualityGoalQuantityGoal}개\n`;

      // this.labelGoalList.forEach((labelGoal) => {
      //   compoundedQualityGoal.qualityGoal.labelQualityGoal[
      //     labelGoal.labelName
      //   ] = labelGoal;
      //   const { labelName, description: _, type, method, ...info } = labelGoal;
      //   confirmText +=
      //     `\n이름: ${labelName} 형식: ${type} 방식: ${method}\n` +
      //     `내용: ${JSON.stringify(info)}`;
      // });

      // if (
      //   confirm(confirmText) &&
      //   (await this.postQualityGoal(compoundedQualityGoal))
      // )
      //   this.$emit('closeModal');
    },
    async postQualityGoal(qualityGoal: QualityGoalType): Promise<boolean> {
      const workpsaceId = this.$route.params.workspaceId;
      this.$store.commit('startLoading');
      const status = await createQualityGoal(workpsaceId, qualityGoal);

      let isOk = false;

      switch (status) {
        case 201: {
          alert('등록되었습니다.');
          isOk = true;
          break;
        }
        case 401: {
          alert('인증에 실패했습니다. 다시 로그인 해주세요.');
          break;
        }
        case 404: {
          alert('워크스페이스를 찾을 수 없습니다.');
          break;
        }
        default: {
          alert('품질 목표 등록에 실패했습니다.');
          break;
        }
      }

      this.$store.commit('stopLoading');

      return isOk;
    },
  },
});
